export default __webpack_public_path__ + "static/0031-4170408c7d27a6555b6e598a5fc6fdd0.png";